import { propClassName } from '@/styles/SavedArticles';
import { cn } from 'lib/utils/cn';
import type { ClassNameProp, Component, ComponentProps } from 'types/component';

export interface SavedArticlesArticleCaptionProps extends ComponentProps<'h4'> {
  variant?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
}

export const SavedArticlesArticleCaptionComponent: Component<SavedArticlesArticleCaptionProps> = ({
  className,
  variant,
  colors,
  size,
  children,
  ...props
}) => {
  const variantClassName = propClassName('article_caption_variant', variant, 'default');
  const colorsClassName = propClassName('article_caption_colors', colors, 'default');
  const sizeClassName = propClassName('article_caption_size', size, 'default');
  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  return (
    <h4 className={componentClassName} {...props}>
      {children}
    </h4>
  );
};
